<div class="fab-item">
    <button (click)="onClick()" pTooltip="Limpiar Filtros" [tooltipPosition]="'left'">
        <i class="pi pi-filter-slash"></i>
    </button>
</div>
